<div class="fixed-top">
  <div class="d-flex flex-column">
    <app-header #header></app-header>
    <app-breadcrumb></app-breadcrumb>
  </div>
</div>
<div id="backset" style="height:45px;"></div>
<nav aria-label="breadcrumb">
  <ol class="breadcrumb mb-0">
    <li class="breadcrumb-item active" (click)="employeeCareerPathNavigate()">Employee Career Path &nbsp;</li>

    <li class="breadcrumb-item active" aria-current="page">Program Catalogue</li>
  </ol>
</nav>
<div class="search-bar Custom-Search mx-auto mb-3" style="height: 5%; margin: 40px;">
  <button type="submit" class="msicon" (click)="searchAllPrograms(elasticSearch.value)">
    <span class="material-symbols-outlined">search</span>
  </button>
  <input #elasticSearch type="search" class="elastic-search" placeholder="Search by Program"
    (keydown.enter)="onSearchTextChanged(elasticSearch.value)" (keyup)="clearSearch(elasticSearch.value)" >
  <button type="submit" class="msicon" (click)="clearSearchProgramText(elasticSearch)" *ngIf="elasticSearch.value">
    <span class="material-symbols-outlined"> close</span>
  </button>
</div>
<div class="d-flex justify-content-between heading">
  <div *ngIf="isCareerPathPrograms != null && isCareerPathPrograms != ''">
    <span class="heading_Programs">{{isCareerPathPrograms}}<br></span>
  </div>
</div>


<div class="row grid-data tab-background">
  <div class="col-md-3 col-sm-6 pl-0" *ngFor="let card of allPrograms; index as i">
    <div class="card" (click)="goToProgramDetails(card)">
      <div class="card-image">
        <img [src]="card.programImage?card.programImage : '../../../../assets/images/employeeCareer/code.jpg'">
        <div class="text-overlay">
          <span class="inprogress" *ngIf="card.status == 'InProgress' ">In Progress</span>
          <span class="completed" *ngIf="card.status == 'Completed' ">Completed</span>
          <span class="notstarted" *ngIf="card.status == 'Not Started' ">Not Started</span>
        </div>
      </div>
      <div class="card-content">
        <div class="department">
          <span class="department-name">{{card.departmentPathName || card.subGroup}}</span>
        </div>
        <p class="card-title" title="{{card.programName}}" matTooltip="{{card.programName}}">
          {{card.programName}}
        </p>
        <hr>
        <div class="d-flex counts">
          <div class="col-6">
            <i class="fa fa-line-chart"></i>
            <span class="pl-2">{{card?.complexityLevel}}</span><br>
            <i class="fa fa-caret-square-o-right"></i>
            <span class="pl-2">{{card?.totalCourses}} Courses</span>
          </div>
          <vr class="vertical"></vr>
          <div class="col-6">
            <i class="fa fa-clock-o"></i>
            <span class="pl-2">{{card?.totalTopicsLength}} total hours</span><br>
            <i class="fa fa-list-alt"></i>
            <span class="pl-2">{{card?.totalTopics}} Topics</span>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="(i + 1) % 4 == 0 || i == allPrograms.length - 1">
      <div class="row"></div>
    </ng-container>
  </div>
  <span class="NoPrograms" *ngIf="allPrograms?.length <= 0 && !isloading">No Programs Found</span>
  <div class="view-more d-flex" *ngIf="allPrograms?.length >= 8 && showAllViewMore">
    <span (click)="loadAllPrograms()">View More</span>
  </div>
</div>
<!-- <div class="view-more d-flex" *ngIf="allPrograms?.length >= 8 && showAllViewMore">
            <span (click)="loadAllPrograms()">View More</span>
          </div> -->
<!-- <div class="view-more d-flex" *ngIf="allPrograms?.length <= 0">
            <span>No Programs Found</span>
          </div> -->
